var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file modal组件
 * @author (zhaojun10)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { classPrefix } from '../../common/util';

import './Modal.less';
/*
 * 参数说明
 * maskClosable 点击蒙层是否允许关闭 默认是true
 *
 */

var ModalBase = function (_Component) {
    _inherits(ModalBase, _Component);

    function ModalBase() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ModalBase);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalBase.__proto__ || Object.getPrototypeOf(ModalBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            topShadow: false,
            bottomShadow: false
        }, _this.contentScroll = function () {
            var scrollTop = _this.modalContent.scrollTop;
            var scrollHeight = _this.modalContent.scrollHeight;
            var clientHeight = _this.modalContent.clientHeight;
            var topShadow = true;
            var bottomShadow = true;
            if (scrollHeight === clientHeight) {
                topShadow = bottomShadow = false;
            } else if (scrollHeight > clientHeight) {
                if (scrollTop === 0) {
                    topShadow = false;
                }
                if (scrollTop === scrollHeight - clientHeight) {
                    bottomShadow = false;
                }
            }
            _this.setState({
                topShadow: topShadow,
                bottomShadow: bottomShadow
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ModalBase, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.contentScroll();
            this.modalContent.addEventListener('scroll', this.contentScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.modalContent.removeEventListener('scroll', this.contentScroll);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames2,
                _classnames3,
                _classnames4,
                _classnames5,
                _this2 = this,
                _classnames7;

            var _props = this.props,
                children = _props.children,
                onOk = _props.onOk,
                onCancel = _props.onCancel,
                title = _props.title,
                formFlag = _props.formFlag,
                width = _props.width,
                className = _props.className,
                buttonType = _props.buttonType,
                okText = _props.okText,
                CancelText = _props.CancelText,
                buttonReverse = _props.buttonReverse,
                type = _props.type,
                warningType = _props.warningType,
                maskClosable = _props.maskClosable,
                singleButton = _props.singleButton,
                classPrefix = _props.classPrefix,
                responsive = _props.responsive,
                shadow = _props.shadow;

            var mainStyle = width ? { width: width } : {};
            var popUpClass = classnames(_defineProperty({}, classPrefix + '-popup', true));
            var popUpModalClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-popup-modal', true), _defineProperty(_classnames2, className, !!className), _defineProperty(_classnames2, 'responsive', responsive), _defineProperty(_classnames2, classPrefix + '-modal-shadow', shadow), _classnames2));
            var contentClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, classPrefix + '-modal-content', true), _defineProperty(_classnames3, classPrefix + '-modal-content-no-padding', formFlag), _defineProperty(_classnames3, className, !!className), _classnames3));
            var footerClass = classnames((_classnames4 = {}, _defineProperty(_classnames4, classPrefix + '-modal-footer', buttonType === 0), _defineProperty(_classnames4, classPrefix + '-modal-footer2', buttonType === 1), _defineProperty(_classnames4, 'has-shadow', this.state.bottomShadow), _classnames4));
            var titleClass = classnames((_classnames5 = {}, _defineProperty(_classnames5, classPrefix + '-modal-title', true), _defineProperty(_classnames5, 'has-shadow', this.state.topShadow), _classnames5));
            var buttonArray = void 0;
            if (formFlag !== true) {
                var _classnames6;

                buttonArray = [React.createElement(
                    'div',
                    {
                        key: classPrefix + '-button1',
                        className: classnames((_classnames6 = {}, _defineProperty(_classnames6, classPrefix + '-modal-fb', true), _defineProperty(_classnames6, classPrefix + '-modal-fb-single', singleButton), _classnames6)),
                        onClick: function onClick(e) {
                            if (onOk) {
                                onOk(e);
                            }
                        }
                    },
                    okText
                ), !singleButton ? React.createElement(
                    'div',
                    {
                        key: classPrefix + '-button2',
                        className: classPrefix + '-modal-fb ' + classPrefix + '-modal-fb1',
                        onClick: function onClick() {
                            if (onCancel) {
                                onCancel();
                            }
                        }
                    },
                    CancelText
                ) : null];
                if (buttonType === 0) {
                    !singleButton && buttonArray.splice(1, 0, React.createElement('div', { className: classPrefix + '-line', key: 'spui-line' }));
                }
                buttonArray = buttonReverse ? buttonArray.reverse() : buttonArray;
            }
            return React.createElement(
                'div',
                null,
                React.createElement('div', { className: popUpClass, key: 'spui-modal-popup' }),
                React.createElement(
                    'div',
                    {
                        className: popUpModalClass,
                        key: 'spui-modal-main',
                        ref: function ref(el) {
                            _this2.elementModalouter = el;
                        },
                        onClick: function onClick(e) {
                            if (e.target === _this2.elementModalouter) {
                                if (maskClosable && onCancel) {
                                    onCancel();
                                }
                            }
                        }
                    },
                    React.createElement(
                        'div',
                        {
                            className: classnames((_classnames7 = {}, _defineProperty(_classnames7, classPrefix + '-popup-main', true), _defineProperty(_classnames7, classPrefix + '-modal-large', type === 'large'), _defineProperty(_classnames7, classPrefix + '-modal-warning', warningType === true), _defineProperty(_classnames7, classPrefix + '-modal-form', formFlag === true), _classnames7)),
                            style: mainStyle
                        },
                        React.createElement(
                            'div',
                            { className: titleClass },
                            React.createElement(
                                'h3',
                                null,
                                title
                            ),
                            React.createElement('em', {
                                className: classPrefix + '-modal-x',
                                onClick: function onClick() {
                                    if (onCancel) {
                                        onCancel();
                                    }
                                }
                            })
                        ),
                        React.createElement(
                            'div',
                            {
                                className: contentClass,
                                ref: function ref(el) {
                                    _this2.modalContent = el;
                                }
                            },
                            children
                        ),
                        formFlag !== true && React.createElement(
                            'div',
                            { className: footerClass },
                            buttonArray ? buttonArray : '',
                            React.createElement('div', { style: { clear: 'both' } })
                        )
                    )
                )
            );
        }
    }]);

    return ModalBase;
}(Component);

export default ModalBase;


ModalBase.defaultProps = {
    maskClosable: true,
    classPrefix: classPrefix,
    title: '标题',
    okText: '确定',
    CancelText: '取消',
    buttonType: 0,
    shadow: false
};
ModalBase.propTypes = {
    children: PropTypes.node,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    title: PropTypes.string,
    formFlag: PropTypes.bool,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    buttonType: PropTypes.number,
    okText: PropTypes.string,
    CancelText: PropTypes.string,
    buttonReverse: PropTypes.bool,
    type: PropTypes.string,
    warningType: PropTypes.bool,
    classPrefix: PropTypes.string,
    maskClosable: PropTypes.bool,
    singleButton: PropTypes.bool,
    responsive: PropTypes.bool,
    shadow: PropTypes.bool
};